import { UserGetWrongRequest, UserGetWrongResponse } from '../../../types/user'
import { useApiPostQuery } from '../useApi'

export const useUserGetWrong = (requestData: UserGetWrongRequest) => {
  return useApiPostQuery<UserGetWrongResponse>(
    '/user/getWrong',
    ['userWrong', requestData],
    requestData,
    !!requestData.ID // ID가 있을 때만 활성화
  )
}
